import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { puedeEditarPagina } from "../services/permisoService";
import { setAccesos, setParametros } from "../redux/seguridadSlice";
import * as seguridadService from "../services/seguridadService";

/**
 * Estado de edicion comun de todas las pantallas de mantenimiento.
 *
 * Las pantallas se entran con isReadOnly y lo pasan a cada componente para
 * deshabilitar todos sus controles. El permiso sale de los accesos del usuario
 * (seguridad) y, con la seguridad desactivada, de permisoService. El bloqueo
 * se activa al guardar, tal como en Person/Edit.
 *
 * @param {string} pagina Llave de la pagina, por ejemplo "periodo".
 */
export const useMantenimiento = (pagina) => {
    const dispatch = useDispatch();
    const accesos = useSelector((state) => state.seguridad?.accesos) || [];
    const seguridadActiva = useSelector((state) => state.seguridad?.seguridadActiva) || "N";

    // Una vez por sesion se consultan los accesos y los parametros de la
    // seguridad.
    useEffect(() => {
        if (accesos.length > 0) return;

        const usuario = sessionStorage.getItem("sisdet.usuario");

        seguridadService.getsParametros()
            .then((parametros) => dispatch(setParametros(parametros)))
            .catch((err) => { console.log("Err: ", err) });

        if (!usuario) return;

        seguridadService.getsAccesosUsuario(usuario)
            .then((lista) => dispatch(setAccesos(lista || [])))
            .catch((err) => { console.log("Err: ", err) });
    }, []);

    const [guardado, setGuardado] = useState(false);

    // Con la seguridad activa manda el acceso del usuario; si esta desactivada
    // se usa el permiso por defecto (hoy, todos pueden editar).
    const puedeEditar = seguridadActiva === "S"
        ? accesos.includes(pagina + ".editar")
        : puedeEditarPagina(pagina);

    const isReadOnly = !puedeEditar || guardado;

    const setIsReadOnly = useCallback((valor) => setGuardado(!!valor), []);
    const habilitarEdicion = useCallback(() => setGuardado(false), []);
    const bloquearEdicion = useCallback(() => setGuardado(true), []);

    return {
        pagina,
        puedeEditar,
        isReadOnly,
        setIsReadOnly,
        habilitarEdicion,
        bloquearEdicion,
    };
};

export default useMantenimiento;